import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from '../../components/Icons';
import UploadMusicBg from '../Gallery/UploadMusicBg';
import { useParams } from 'react-router-dom';
import { postData, putData } from '../../lib/utils';
import { useContext, useEffect, useRef, useState } from 'react';
import { Context } from "../contexts/AppContext"; 
import { faSpinner, faMusic } from '@fortawesome/free-solid-svg-icons';

function MusicSideNav() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const { galleryId } = useParams();

  const [isUploading, setIsUploading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [uploadingFileName, setUploadingFileName] = useState("");

  


  useEffect(()=>{ 
   const filePath = appState?.currentGalleryData?.backgroundMedia?.musicUrl;
    if(filePath)
    {
      const fileName = filePath.split('/').pop();
      setUploadedFileName(fileName)
    }
  },[appState])
const deleteFile=()=>{
    setUploadedFileName("")
}
  const audioOnPrg = () => {
    setIsUploading(true);
    console.log("audio on progress");
  }
 

  const audioUploadedDone = async(file) => {
    setIsUploading(false);
    setUploadedFileName(file.name); // Capture the uploaded file name
    console.log("audio uploaded done");
      const { currentFolderName, currentGalleryName } = appState;

  // File name se spaces remove/replace karna
  const sanitizedFileName = file.name.replace(/\s+/g, "_");

  // const musicUrl = `${currentFolderName}/${currentGalleryName}/${sanitizedFileName}`;
  const musicUrl = `${appState.assetsUrl}/${sanitizedFileName}`;

  console.log("Music Uploaded DONE  ", musicUrl);

  const json = await putData(`galleries/gallery/${galleryId}/background`, {
    musicUrl: musicUrl,
  });

  if (json) {
 setAppState((prevState) => ({
  ...prevState,
  currentGalleryData: {
    ...prevState.currentGalleryData,
    backgroundMedia: {
      ...prevState.currentGalleryData.backgroundMedia,
      musicUrl: json.backgroundMedia.musicUrl,
    },
  },
}));

    setUploadingFileName(sanitizedFileName);
   
    setUploadedFileName(sanitizedFileName)
   
  }
  }

  

//   const audioUploadedDone = async (file) => {
//   setIsUploading(false);
//   setUploadedFileName(file.name);

//   console.log("audio uploaded done");

//   const sanitizedFileName = file.name.replace(/\s+/g, "_");
//   const musicUrl = `${appState.assetsUrl}/${sanitizedFileName}`;

//   console.log("Music Uploaded DONE", musicUrl);

//   // 🔥 1. Start polling S3 file existence
//   const checkInterval = setInterval(async () => {
//     try {
//       const res = await postData("products/check-file", {
//         fileName: musicUrl,
//       });

//       console.log("Checking file…", res);

//       if (res.exists) {
//         console.log("🎉 File found on S3!");

//         clearInterval(checkInterval); // Stop interval

//         // 🔥 2. Now update gallery background
//         const json = await putData(
//           `galleries/gallery/${galleryId}/background`,
//           { musicUrl: musicUrl }
//         );

//         if (json) {
//           setAppState((prevState) => ({
//             ...prevState,
//             currentGalleryData: {
//               ...prevState.currentGalleryData,
//               backgroundMedia: {
//                 ...prevState.currentGalleryData.backgroundMedia,
//                 musicUrl: json.backgroundMedia.musicUrl,
//               },
//             },
//           }));

//           setUploadingFileName(sanitizedFileName);
//           setUploadedFileName(sanitizedFileName);
//         }
//       }
//     } catch (error) {
//       console.log("file check error:", error);
//     }
//   }, 1000); // 🔁 check every 1 second
// };
  const uploadFailed = async (file) => {
    alert("Upload failed Check Your Internet Connection");
    setIsUploading(false);
  }

 const handleUpload =   (file) => {
 
   setIsUploading(true);
   setUploadingFileName(file.name);
   
};

  return (
    <div className='space-y-4'>
      <div className="font-bold text-lg py-2 px-1">
        Ambient Music
      </div>

      <div className='border px-4 py-2 bg-[#f0f2f5] text-center'>
       {isUploading ? (
  // ✅ Agar file abhi upload ho rahi hai
  <>
    <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-yellow-800" />
    <div className="text-sm font-semibold py-2">{uploadingFileName}</div>
  </>
) : uploadedFileName ? (
  // ✅ Agar file already upload ho chuki hai
  <>
    <FontAwesomeIcon icon={faMusic} size="2x" className="text-yellow-800" />
    <div className="text-sm font-semibold py-2">{uploadedFileName}</div>
  </>
) : (
  // ✅ Agar abhi tak koi file nahi hai
  <>
    <FontAwesomeIcon icon={faMusic} size="2x" className="text-yellow-800" />
    <div className="text-xs font-bold py-2">No track added yet</div>
  </>
)}


        <div className="text-xs text-gray-400 py-2">
          Upload an audio track in MP3, AAC, WAV or OGG Format
        </div>

        <div className='flex gap-2 items-center'>
          <UploadMusicBg
            txt={"Upload Music"}
            type={"musicBg"}
          handleUpload={handleUpload}
            audioOnPrg={audioOnPrg}
            audioUploadedDone={audioUploadedDone}
            uploadFailed={uploadFailed}
            deleteFile={deleteFile}
          />
        </div>
      </div>
    </div>
  );
}

export default MusicSideNav;
